// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as AssetStore$PorterinFeature from "../../../ui/assets/AssetStore.mjs";

var dropdown_arrow = {
  src: AssetStore$PorterinFeature.whiteArrowDropDown,
  width: 16.0,
  height: 16.0,
  alt: "Dropdown Icon"
};

var clear_input_icon = {
  src: AssetStore$PorterinFeature.clearInputIcon,
  width: 20.0,
  height: 20.0,
  alt: "Clear Input Icon"
};

function prefillField(prefill, field) {
  if (prefill !== undefined) {
    return Belt_Option.getWithDefault(Curry._1(field, prefill), "");
  } else {
    return "";
  }
}

var locate_location_icon = {
  src: AssetStore$PorterinFeature.locationTrackIcon,
  width: 20.0,
  height: 20.0,
  alt: "Clear Input Icon"
};

function prefillMobile(prefill) {
  return prefillField(prefill, (function (val) {
                return val.mobile;
              }));
}

function prefillName(prefill) {
  return prefillField(prefill, (function (val) {
                return val.name;
              }));
}

function prefillRequirementType(prefill) {
  return prefillField(prefill, (function (val) {
                return val.requirement_type;
              }));
}

var header_logo = {
  src: "https://nest-platform-assets.porter.in/arrow_left_default_7016da1f3f/arrow_left_default_7016da1f3f.svg",
  width: 26.0,
  height: 20.266,
  alt: "Porter Logo Blue"
};

var close_icon = {
  src: "https://nest-platform-assets.porter.in/cross_icon_29cf70155f/cross_icon_29cf70155f.svg",
  width: 14.0,
  height: 14.0,
  alt: "Cross Icon"
};

var left_arrow = {
  src: "https://nest-platform-assets.porter.in/arrow_left_default_7016da1f3f/arrow_left_default_7016da1f3f.svg",
  width: 24.0,
  height: 24.0,
  alt: "Back Icon"
};

var profile_icon_black = {
  src: "https://nest-platform-assets.porter.in/user_filled_black_7bba9e9360/user_filled_black_7bba9e9360.svg",
  width: 33.0,
  height: 33.0,
  alt: "User Icon Filled"
};

var input_error = {
  src: "https://nest-platform-assets.porter.in/payment_failure_57b845ed2a/payment_failure_57b845ed2a.svg",
  width: 20.0,
  height: 20.0,
  alt: "Input Error Icon"
};

export {
  header_logo ,
  close_icon ,
  left_arrow ,
  profile_icon_black ,
  dropdown_arrow ,
  input_error ,
  clear_input_icon ,
  prefillField ,
  locate_location_icon ,
  prefillMobile ,
  prefillName ,
  prefillRequirementType ,
}
/* No side effect */
